export const createComments = (data: any) => {
    if (Array.isArray(data)) {
        return data.map((comment) => {
            const author = comment.author || {};
            return {
                userId: (author.user_id ?? '').toString(),
                comId: comment.id,
                fullName: author.name ?? 'Nieznany',
                text: comment.comment,
                avatarUrl: `https://ui-avatars.com/api/name=${(author.short_name ?? '?')
                    }&background=${(author.icon_color ?? '#cccccc').replace(
                        /#/g,
                        ""
                    )}&color=ffffff`,
                replies: [],
            };
        });
    }
    return [];
};